import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslate } from '../../../components/TranslationText';
import { OrderActions } from '../constants/semenActions';

/**
 * Banner displayed when creating an additional dose, linking back to the original request.
 * 
 * @param {object} orderDetails - The current order details containing isAdditionalDose and originalOrderId
 * @param {string} semenMarketId - The current semen market ID
 */
export default function SemenAdditionalDoseBanner({ orderDetails, semenMarketId }) {
    const { translate } = useTranslate();

    if (!orderDetails?.isAdditionalDose || !orderDetails?.originalOrderId) {
        return null;
    }

    return (
        <div className="bg-light border rounded p-3 mb-main d-flex align-items-center flex-wrap gap-2">
            <h6 className="mb-0 text-dark bold">
                {translate("web.additionalDoseOriginalRequest", "This request is an extra dose based on the original reference:")}
            </h6>
            <Link
                to={`/semenCheckout?orderId=${orderDetails.originalOrderId}&semenMarketId=${semenMarketId || orderDetails.semenMarketId}&action=${OrderActions.View}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-danger bold text-decoration-none d-flex align-items-center gap-1"
                style={{ fontSize: '1rem' }}
            >
                <i className="fa-solid fa-arrow-up-right-from-square" /> 
                <span className="mt-1">{orderDetails.originalReferenceNumber}</span>
            </Link>
        </div>
    );
}
